module.exports = __webpack_public_path__ + "img/portal-woman.46e58376.png";